/*
 * @Date: 2026-03-12 22:37:57
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-05-18 19:06:29
 */
import { defineAppConfig } from 'ice';
import { defineFrameworkConfig } from '@ice/plugin-icestark/types';
import { defineRequestConfig } from '@ice/plugin-request/types';
import PageLoading from './components/PageLoading';
import Entry from './entry';

const envCDNMap: Record<string, string> = {
  dev: 'https://robo-static-dev-obs.momenta.cn',
  test: 'https://robo-static-qa-obs.momenta.cn',
  online: 'https://robo-static-online-obs.momenta.cn',
};

// 子应用路径映射，key 为路由前缀，value 为 CDN 下的 HTML 路径（按需扩展）
const pathMap: Record<string, string> = {
  // '/some-path': '/some-micro-app/index.html',
};

const entryMap: Record<string, Record<string, string>> = {};
Object.keys(envCDNMap).forEach((env) => {
  entryMap[env] = {};
  Object.keys(pathMap).forEach((key) => {
    entryMap[env][key] = envCDNMap[env] + pathMap[key];
  });
});

// ─── IceStark Framework 配置 ──────────────────────────────────────────────────

export const icestark = defineFrameworkConfig(() => ({
  layout: Entry,
  getApps: () => {
    const originMapData = entryMap[ENV] || {};
    return Object.keys(originMapData).map((key) => ({
      path: key,
      title: 'TOS',
      loadScriptMode: 'script' as const,
      entry: originMapData[key] + '?ts=' + Date.now(),
    }));
  },
  appRouter: {
    LoadingComponent: PageLoading,
  },
}));

export default defineAppConfig(() => ({
  app: {
    rootId: 'app',
  },
}));

// ─── 请求基础配置 ─────────────────────────────────────────────────────────────

export const request = defineRequestConfig(() => ({
  baseURL: '/',
}));
